import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import Navgation from './Navgation'
import { Link } from 'react-router-dom'

function MainNavigation() {
    return (
        <>
            <Navbar className='nav_bar' fixed='top' collapseOnSelect expand="lg" bg="light" variant="dark">
                <Container>
                    <img src='/images/logo/logo.jpg' alt='logo..' className='logo_img' />
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto main_nav">
                            <Nav.Link as={Link} to="/">Home</Nav.Link>
                            <Nav.Link as={Link} to="/about">About us</Nav.Link>
                            <Nav.Link as={Link} to="/services">Services </Nav.Link>
                            <Nav.Link as={Link} to="/facilities">Facilities</Nav.Link>
                            <Nav.Link as={Link} to="/blogs">Blogs</Nav.Link>
                            <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                        </Nav>
                        <Nav className='main_nav_one' >
                            <Nav.Link href="#deets" className='main_nav_one_link'> Call for Apppointments </Nav.Link>
                            <Nav.Link eventKey={2} href="#memes" className='main_nav_one_link_one'> +918039652916  </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default MainNavigation